import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocalisationService } from '../../services/localisation.service';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';
import { Ville } from '../../../identite/shared/classes/ville';
import { debounceTime, filter } from 'rxjs/operators';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';
import {Pagination} from "../../../core/shared/classes/pagination";

@Component({
    selector: 'app-admin-list-ville',
    templateUrl: './admin-list-ville.component.html',
    styleUrls: ['./admin-list-ville.component.css']
})
export class AdminListVilleComponent implements OnInit {

    selected = new FormControl(0);
    lstPays: any[];
    newVille = new Ville({vil_custom: '1'});
    @Input() payId: string;

    villes: Ville[];
    villeSearchTerm: FormControl = new FormControl();

    disabledIdPays = '2';
    aclConfig: AclAccess;

    pagination: Pagination = null;
    page = 1;
    perPage = 10;

    constructor(
        private localisationService: LocalisationService,
        private storageService: StorageService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));

        this.villes = [];
        this.getVilles();
        this.getPays();
        this.initSearchVille();
    }

    onPaysChange(payId) {
        if (payId) {
            this.getVilles(this.villeSearchTerm.value, true);
        }
    }

    initSearchVille() {
        this.villeSearchTerm.valueChanges
        .pipe(
            debounceTime(400),
            //filter((value: string) => value && value.length > 2)
        )
        .subscribe(searchTerm => this.getVilles(searchTerm, true));
    }

    loadMoreVille() {
        this.page += 1;
        this.getVilles(this.villeSearchTerm.value);
    }

    getVilles(searchTerm = null, force = false) {
        if (!this.payId)
            return;
        this.localisationService.getVilles(this.payId, searchTerm, 'withAcl', {page: this.page, perPage: this.perPage})
        .subscribe(retour => {
            if (retour.status === 200) {
                if (force) {
                    this.villes = [];
                    this.page = 1;
                    this.perPage = 10;
                }
                retour.data.listing.forEach(element => {
                    this.villes.push(new Ville(element));
                });
                this.pagination = retour.data.pagination;
            }
        });
    }

    getPays() {
        this.lstPays = [];
        this.localisationService.getPays()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.lstPays.push(element);
                });
            }
        });
    }

    selectTab(event: any) {
        this.selected.setValue(event);
    }

    insertVille(ville: Ville) {
        if (!this.payId)
            return;
        ville.vil_pay_id = this.payId;
        this.localisationService.insertVille(ville)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.getVilles(this.villeSearchTerm.value, true);
                this.newVille = new Ville({vil_pay_id: this.payId, vil_custom: '1'});
                this.alertService.success(TRANSLATE('Ville ajoutée avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateVille(ville: Ville) {
        this.localisationService.updateVille(ville.vil_id, ville)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Ville modifiée avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteVille(ville: Ville) {
        this.localisationService.deleteVille(ville.vil_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Ville supprimée avec succès'));
                this.getVilles(this.villeSearchTerm, false);
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }
}
